// Defaults to the hosted APIs. To point at a local backend, set these in .env.development.local:
//   REACT_APP_IDENTITY_API_URL=http://localhost:5194/identity/api/v1
//   REACT_APP_KISAN_VANI_API_URL=http://localhost:5155/kisan-vani/api/v1
const API_BASE_URLS = {

  // Set REACT_APP_KISAN_VANI_API_URL / REACT_APP_IDENTITY_API_URL in .env.local to point at locally running
  // services, e.g. http://localhost:<port>/kisan-vani/api/v1 and http://localhost:5194/identity/api/v1
  kisanVani: process.env.REACT_APP_KISAN_VANI_API_URL || 'https://kvaniapi.agribegri.com/kisan-vani/api/v1',

  identity: process.env.REACT_APP_IDENTITY_API_URL || 'https://idsapi.agribegri.com/identity/api/v1',
};

export default API_BASE_URLS;
